import {roleList, orgList} from '@/api/remote'

const state = {
  roles: [],
  orgs: [],
  orgTypes: [
    {code: 'company', name: '公司', icon: 'el-icon-office-building', disabled: false},
    {code: 'department', name: '部门', icon: 'el-icon-postcard', disabled: false},
    {code: 'group', name: '小组', icon: 'el-icon-coin', disabled: false},
  ],
}
const mutations = {
  initRoles(state) {
    roleList().then(res => {
      state.roles = res.data
    });
  },
  addRoles(state, role) {
    state.roles.push(role);
  },
  initOrgs(state) {
    orgList().then(res => {
      state.orgs = res.data
    });
  },
  addOrgs(state, role) {
    state.orgs.push(role);
  },
}
const getters = {
  getRoleByCode: (state) => (code) => {
    let selected = state.roles.find(item => item.code === code);
    return selected ? selected : {};
  },
  getOrgByCode: (state) => (code) => {
    let selected = state.orgs.find(item => item.code === code);
    return selected ? selected : {};
  },
  getOrgTypeIconByCode: (state) => (code) => {
    let type = state.orgTypes.find(item => item.code === code);
    if (type) {
      return type.icon;
    } else {
      return '';
    }
  },
}
export default {
  state: state,
  mutations: mutations,
  getters: getters
}
